import React from 'react'
import PropTypes from 'prop-types'

import { useTranslation } from 'react-i18next'

import { Button, Form, Input, Modal, Select, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'

const BankStatementImportPaymentConfirms = ({
    visibleModal,
    saving,
    onSubmit,
    onToggleVisibleModal
}) => {
    const { i18n } = useTranslation(['bankStatements', 'confirms'])

    const handleSubmit = values => {
        const fileList = values.file || []
        const file = fileList.length > 0 ? fileList[0].originFileObj || null : null
        
        const params = {
            ...values,
            file
        }

        console.log('on-submit params:', params)
        onSubmit({ params })
    }

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 12 }
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 }
        }
    }

    const formItemLayoutWithOutLabel = {
        wrapperCol: {
            xs: { span: 24, offset: 0 },
            sm: { span: 12, offset: 12 }
        }
    }

    const normFile = e => {
        let fileList = [...e.fileList]
        fileList = fileList.slice(-1)
        return fileList
    }

    return (<>
        <Button key="import-button" onClick={onToggleVisibleModal} type="primary">
            {i18n.t('bankStatements:importPaymentConfirms')}
        </Button>
        <Modal
            key="import-modal"
            title={i18n.t('bankStatements:importPaymentConfirms')}
            open={visibleModal}
            onCancel={onToggleVisibleModal}
            footer={null}>
            <Form onFinish={handleSubmit} {...formItemLayout}>
                <Form.Item
                    label={i18n.t('bankStatements:id')}
                    name='number'
                    rules={[{ message: i18n.t('bankStatements:idRequired'), required: true }]}
                >
                    <Input placeholder={i18n.t('bankStatements:enterId')} />
                </Form.Item>

                <Form.Item
                    label={i18n.t('bankStatements:paymentMethod')}
                    name='payment_method'
                    rules={[{ message: i18n.t('bankStatements:paymentMethodRequired'), required: true }]}
                    initialValue="qr"
                >
                    <Select placeholder={i18n.t('bankStatements:selectPaymentMethod')}>
                        <Select.Option value="qr">
                            {i18n.t('bankStatements:qr')}
                        </Select.Option>
                        <Select.Option value="cc">
                            {i18n.t('bankStatements:cc')}
                        </Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label={i18n.t('bankStatements:selectFile')}
                    name='file'
                    getValueFromEvent={normFile}
                    valuePropName='fileList'
                    extra="excel or csv file"
                >
                    <Upload beforeUpload={() => { return false }} listType="text">
                        <Button>
                            <UploadOutlined /> Click to upload
                        </Button>
                    </Upload>
                </Form.Item>

                <Form.Item key="actions" {...formItemLayoutWithOutLabel}>
                    <Button htmlType="submit" loading={saving} type="primary">
                        {i18n.t('bankStatements:import')}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    </>);
}

BankStatementImportPaymentConfirms.propTypes = {
    visibleModal: PropTypes.bool,
    saving: PropTypes.bool,
    onSubmit: PropTypes.func,
    onToggleVisibleModal: PropTypes.func,
}

BankStatementImportPaymentConfirms.defaultProps = {
    visibleModal: false,
    saving: false,
    onToggleVisibleModal: () => {},
    onSubmit: () => {}
}

export default BankStatementImportPaymentConfirms
